// config.js

const bizIcon = "https://mybizsolutions.us/static/media/icon-app-logo.83ff8bf39a11df9fb7ac.jpg";
const imageOne = "https://media.istockphoto.com/id/2175973039/photo/modern-luxury-house-with-spacious-driveway-and-garden.jpg?s=612x612&w=0&k=20&c=DsKgarLeD6Kf8vCAD1MRSHlWS9RmTDL0Vl2BLT2K0V0=";
const imageTwo = "https://media.istockphoto.com/id/187582818/photo/suburban-brown-house-with-a-blue-door-on-a-sunny-day.jpg?s=612x612&w=0&k=20&c=AbUbynXdYfH_mOuFkspnx69ojpq_xZRaIKnACDVL6Hc=";
const imageThree = "https://media.istockphoto.com/id/97609833/photo/high-rise-condos.jpg?s=612x612&w=0&k=20&c=GT6yynU9PbRX1F8Pv_I0FZE2hlRYWIK2LtJhqZNnLJ4=";
const imageFour = "https://media.istockphoto.com/id/685298778/photo/aerial-of-neighborhood.jpg?s=612x612&w=0&k=20&c=NFjdXxVm8HoS7YEoVF8WPnnzcJb0o0zPSwlCuE3FfCI=";
const imageFive = "https://images.marketleader.com/MarketingImages/43/2403943_normal.jpg";

export const siteConfig = {
  title: "Konstance Washington | Deluxe Properties",
  metaDescription: "Konstance Washington | Deluxe Properties",
  theme: {
    primaryColor: "red-600",
    secondaryColor: "gray-900",
    accentColor: "text-red-500"
  },
  logo: {
    src: bizIcon,
    alt: "Konstance Washington | Deluxe Properties",
  },
  navigation: [
    { name: "Services", sectionId: "services" },
    { name: "About", sectionId: "about" },
    { name: "Location", sectionId: "location" },
  ],
  businessDetails: {
    name: "Konstance Washington | Deluxe Properties",
    headline: "Your Real Estate Matchmaker in Louisiana",
    address: "Deluxe Properties 17111 Commerce Centre Dr Ste A, Prairieville, LA 70769-3481",
    description: `
          Konstance Washington, a proud partner of Deluxe Properties, is your trusted guide to buying, selling, and investing in Louisiana real estate.`,
  },
  images: {
    business: {
      src: imageOne,
      alt: "Your Real Estate Matchmaker in Louisiana",
      width: 2432,
      height: 1442
    }
  },
  features: [
    {
      description: 
        "Buying or selling a home is a significant decision, and Konstance Washington is dedicated to making the process smooth and stress-free. With thoughtful guidance at every step, she ensures your real estate experience is exceptional.",
    },
    {
      description: 
        "With a deep knowledge of Louisiana neighborhoods and local market trends, Konstance offers expert advice to help you find the perfect home or maximize the sale of your property.",
    },
    {
      description: 
        "Committed to exceeding expectations, Konstance ensures you feel supported, informed, and empowered throughout your real estate journey. Her personalized approach makes every transaction seamless and rewarding.",
    },
  ],
  services: {
    sectionTitle: "Communities Served",
    description: 
      "Konstance Washington is proud to serve the vibrant and diverse neighborhoods of Prairieville, Baton Rouge, and surrounding areas in Louisiana. She provides personalized real estate services tailored to each client’s needs. Whether you’re a first-time buyer, upgrading to your dream home, or investing in property, Konstance’s local market expertise and community insights ensure you find the perfect fit.",
    callouts: [
        {
          name: 'Single Family',
          description: "Explore Louisiana’s charming neighborhoods with spacious single-family homes that offer excellent amenities and family-friendly environments.",
          imageSrc: imageTwo,
          imageAlt: 'Charming single-family home in Prairieville, LA',
        },
        {
          name: 'Condo/Townhouse/Co-Op',
          description: "Discover modern and convenient living options in Louisiana’s vibrant communities, perfect for professionals and those seeking a low-maintenance lifestyle.",
          imageSrc: imageThree,
          imageAlt: 'Contemporary townhouses in Baton Rouge, LA',
        },
        {
          name: 'Lot/Land/Acreage',
          description: "Looking to build your dream home? Konstance can help you find the ideal lot or acreage with stunning views and prime locations in Louisiana.",
          imageSrc: imageFour,
          imageAlt: 'Scenic plot of land in Prairieville ready for development',
        },
    ],
  },
  about: {
    sectionTitle: "About",
    description: "Konstance Washington brings unmatched expertise in Louisiana real estate, offering clients personalized service backed by deep market knowledge and a passion for excellence. Whether you're buying, selling, or investing, Konstance ensures a seamless and rewarding experience. Her commitment to understanding your unique needs and delivering tailored solutions makes her a trusted partner in achieving your real estate goals.",
    image: {
      src: imageFive,
      alt: "Konstance Washington, trusted Louisiana real estate expert at Deluxe Properties",
      width: 1200,
      height: 800
    }
  },
  location: {
    sectionTitle: "Our Location",
    destinationAddress: "Deluxe Properties 17111 Commerce Centre Dr Ste A, Prairieville, LA 70769-3481",
    googleMapsEmbedUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3444.015713527125!2d-90.94030138488263!3d30.3028439817974!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8626ad3cda8a9ad5%3A0xabcdef123456789!2s17111%20Commerce%20Centre%20Dr%20Ste%20A%2C%20Prairieville%2C%20LA%2070769-3481!5e0!3m2!1sen!2sus!4v1710407450828!5m2!1sen!2sus",
    subCategories: [
      { 
        name: 'Apple Maps', 
        url: 'https://maps.apple.com/?address=17111%20Commerce%20Centre%20Dr%20Ste%20A,%20Prairieville,%20LA%2070769-3481&ll=30.3028,-90.9403&q=17111%20Commerce%20Centre%20Dr',
      },
      { 
        name: 'Bing Maps', 
        url: 'https://www.bing.com/maps?q=17111+Commerce+Centre+Dr+Ste+A,+Prairieville,+LA+70769-3481&FORM=HDRSC6',
      },
      { 
        name: 'Google Earth', 
        url: 'https://earth.google.com/web/search/17111+Commerce+Centre+Dr+Ste+A,+Prairieville,+LA+70769-3481/@30.3028,-90.9403,15a,814.57589625d,35y,0h,0t,0r',
      },
      { 
        name: 'Google Maps', 
        url: 'https://www.google.com/maps/place/17111+Commerce+Centre+Dr+Ste+A,+Prairieville,+LA+70769-3481/@30.3028,-90.9403,15z',
      }
    ]
  },
  contact: {
    sectionTitle: "Ready to Find Your Perfect Property?",
    description: "Contact Konstance Washington | Deluxe Properties to explore your real estate opportunities in Prairieville, LA, and surrounding areas. Whether you’re buying, selling, or investing, Konstance provides expert guidance and personalized support to make your property dreams a reality.",
    socialLinks: {
      facebook: "https://www.thereal-estatequeen.com/",     
      instagram: "https://www.thereal-estatequeen.com/",     
      twitter: "https://www.thereal-estatequeen.com/",     
      linkedin: "https://www.thereal-estatequeen.com/",     
      youtube: "https://www.thereal-estatequeen.com/",     
    },
    contactNumbers: [
      "Mobile: (225) 278-7780",
    ],
    logo: bizIcon,
    emailRecipient: "konstance@deluxepropertiesbr.com"
  },
  footer: {
    bizSolutionsLogo: "https://mybizsolutions.us/static/media/icon-app-logo.83ff8bf39a11df9fb7ac.jpg"
  }
};


